
export class ReportProfileAccessModeModel {
  accessMode: string;
  lastActionDate: Date;
  isSucceeded: boolean;
}
